import { ConfigProvider } from "antd";
import Entry from "./Entry";
// import './types/global';

import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import "theme/index.scss";
import "./RootApp.scss";
import { IntlProvider } from "react-intl";
import { RecoilRoot } from "recoil";
import { useEffect } from "react";
import { getSubdomain } from "app/utils/generic.helper";
import { appMetaConfig } from "global.constants";
import { Mixpanel } from "app/config/Mixpanel";
import { initClarity } from "./app/utils/Analytics";
import { initPosthog } from "./app/utils/GoogleAnalytics";
import posthog from 'posthog-js';
import { useLocation } from 'react-router-dom';

// import RecoilizeDebugger from "recoilize";
// console.log("POSTHOG KEY:", process.env.REACT_APP_POSTHOG_KEY);
// posthog.init(process.env.REACT_APP_POSTHOG_KEY || '', {
//   api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com',
// });
// posthog.init('phc_sqVedcbiO1p6MDNKAwkqNokw9vWJd73mwr8c9CEUn1P',
//   {
//       api_host: 'https://us.i.posthog.com',
//       person_profiles: 'identified_only' 
//   }
// )
function App() {


  const defaultData = {
    colorPrimary: "#0A8394", //2575dcc
  };
  
  useEffect(() => {
    posthog.capture('manual_test_event', {
      custom_prop: 'test',
    });
  }, []);
  // useEffect(() => {
  //   const script1 = document.createElement("script");
  //   script1.src = `https://www.googletagmanager.com/gtag/js?id=G-YGHTMQESH6`;
  //   script1.async = true;
  //   document.head.appendChild(script1);
  
  //   const script2 = document.createElement("script");
  //   script2.innerHTML = `
  //     window.dataLayer = window.dataLayer || [];
  //     function gtag(){dataLayer.push(arguments);}
  //     gtag('js', new Date());
  //     gtag('config', 'G-YGHTMQESH6');
  //   `;
  //   document.head.appendChild(script2);
  // }, []);

  useEffect(() => {
    initPosthog();
  }, []);

  useEffect(() => {
    initClarity();
  }, [])

  

  useEffect(() => {
    const domain = getSubdomain();
    document.title = appMetaConfig[domain || "app"]?.title || "Finkraft"; // Set the document title
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      const sessionStartTime: any = localStorage.getItem("session_start_time"); // Store on Session Start
      const sessionEndTime = new Date().getTime();
      const sessionDuration = (sessionEndTime - sessionStartTime) / 1000; // in seconds
      if (sessionStartTime) {
        Mixpanel.track("Session Duration", {
          session_duration: sessionDuration,
        });
      }
    };

    // Add the event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []); // Empty dependency array ensures this runs once on mount

  useEffect(() => {
    const handleError = (error: ErrorEvent) => {
      posthog.capture('error', {
        error_message: error.message,
        error_stack: error.error?.stack,
        url: window.location.href,
        path: window.location.pathname
      });
    };
  
    window.addEventListener('error', handleError);
    
    // Cleanup
    return () => window.removeEventListener('error', handleError);
  }, []);

  
  
  return (
    <IntlProvider locale="en-IN" defaultLocale="en-IN">
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: defaultData.colorPrimary,
          },
        }}
      >
        <RecoilRoot>
          {/* <RecoilizeDebugger /> */}

          <Router>
            <Entry />
          </Router>
        </RecoilRoot>
      </ConfigProvider>
    </IntlProvider>
  );
}

export default App;
